import styled from "styled-components"

import { Box } from "components/box"
import { ParagraphSmall } from "components/text"

export const Checkbox = styled(Box)`
  border: 1px solid ${props => props.theme.colors.evergreen};
  background-color: ${props => props.theme.colors.white};

  height: 19px;
  min-width: 19px;
  max-width: 19px;

  svg {
    height: 100%;
    width: 100%;
  }
`

export const Label = styled(ParagraphSmall).attrs({ as: "label" })<{ error?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: fit-content;
  text-align: left;
  margin-bottom: ${props => props.theme.space[4]};

  :hover {
    cursor: pointer;
  }

  :focus-within ${Checkbox} {
    outline: ${props => props.theme.colors.melrose} auto 5px;
  }

  ${props =>
    props.error &&
    `
    ${Checkbox} {
      border-color: ${props.theme.colors.salmon};
      background-color: ${props.theme.colors.lightSalmon};
    }
  `}
`
